import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '@environments/environment';
import { ChangePasswordPayload } from '@b2b/features/forgot-password-dialog/core/forgot-password.types';

@Injectable({
  providedIn: 'root',
})
export class ForgotPasswordConnector {
  constructor(private http: HttpClient) {}

  receiveCode(username: string) {
    const url = `${environment.apiService}/b2bcustomer/oauth/forgot-password`;
    return this.http.post<{ message: string }>(url, { username });
  }

  confirmCode(username: string, otp: string) {
    const url = `${environment.apiService}/b2bcustomer/oauth/validate-otp`;
    return this.http.post<{ message: string }>(url, { username, otp });
  }

  sendNewPassword(data: ChangePasswordPayload) {
    const path = data.refreshToken ? 'change-password' : 'reset-password';
    const url = `${environment.apiService}/b2bcustomer/oauth/${path}`;
    return this.http.post<{ message: string }>(url, data);
  }
}
